export class AccessCardCancellationAdd {
  accessCardId: number;
  accessCardCancellationReasonId: number;
  endDate: Date;
}



// WEBPACK FOOTER //
// ./src/app/core/models/access-card-cancellation-add.ts